export const downloadAppCtaTitle = "Download de app"

export const downloadAppCtaBody =
  "Beheer je donaties eenvoudig in de GoodShift app. Start, wijzig en pauzeer wanneer jij wilt. Blijf op de hoogte van de impact die jouw goede doelen maken."
